<template>
  <GhostPage page-key="pages.ghost.reviews" />
</template>

<script setup lang="ts">
definePageMeta({
  i18n: {
    paths: {
      en: '/reviews',
      fr: '/evaluations',
    },
  },
})
</script>
